/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  GetApiV1BmfCurvesCupomDollar200,
  GetApiV1BmfCurvesCupomDollarParams,
  GetApiV1BmfCurvesCupomEuro200,
  GetApiV1BmfCurvesCupomEuroParams,
  GetApiV1BmfCurvesDap200,
  GetApiV1BmfCurvesDapParams,
  GetApiV1BmfCurvesDi200,
  GetApiV1BmfCurvesDiParams,
  GetApiV1BmfCurvesDollar200,
  GetApiV1BmfCurvesDollarParams,
  GetApiV1BmfCurvesEuro200,
  GetApiV1BmfCurvesEuroParams,
  GetApiV1BmfCurvesImpliedIpca200,
  GetApiV1BmfCurvesImpliedIpcaParams,
  GetApiV1BmfCurvesTermCalculate200,
  GetApiV1BmfCurvesTermCalculateParams
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getBmfCurves = () => {
/**
 * Retorna a curva DI interpolada por dias úteis, com taxas nas bases 252 e 360. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data. Quando referenceDate for nulo, busca o último dado disponível no provedor e informa EffectiveDataDate no retorno.
 * @summary Constrói a curva DI BMF
 */
const getBmfCurvesDi = (
    params?: GetApiV1BmfCurvesDiParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesDi200>>,) => {
      return customInstance<GetApiV1BmfCurvesDi200>(
      {url: `/api/v1/bmf-curves/di`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna a curva DAP interpolada por dias úteis, com taxas nas bases 252 e 360. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data. Quando referenceDate for nulo, busca o último dado disponível no provedor e informa EffectiveDataDate no retorno.
 * @summary Constrói a curva DAP BMF
 */
const getBmfCurvesDap = (
    params?: GetApiV1BmfCurvesDapParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesDap200>>,) => {
      return customInstance<GetApiV1BmfCurvesDap200>(
      {url: `/api/v1/bmf-curves/dap`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna a curva de dólar derivada do prêmio do forward USD/BRL da "CURVA DE DOLAR" pronta do source 87 sobre o spot 1D, com taxas nas bases 252 e 360. Não há modo ao vivo: fechamento (D-1) por QuotesRequest e histórico (≤ D-2) via DailyGraph dos tenores. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data. Quando referenceDate for nulo, monta o fechamento de D-1 e informa EffectiveDataDate no retorno.
 * @summary Constrói a curva de dólar BMF
 */
const getBmfCurvesDollar = (
    params?: GetApiV1BmfCurvesDollarParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesDollar200>>,) => {
      return customInstance<GetApiV1BmfCurvesDollar200>(
      {url: `/api/v1/bmf-curves/dollar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna a curva FRC de cupom dólar interpolada por dias úteis, com taxas nas bases 252 e 360. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data.
 * @summary Constrói a curva de cupom dólar BMF
 */
const getBmfCurvesCupomDollar = (
    params?: GetApiV1BmfCurvesCupomDollarParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesCupomDollar200>>,) => {
      return customInstance<GetApiV1BmfCurvesCupomDollar200>(
      {url: `/api/v1/bmf-curves/cupom-dollar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna o IPCA implícito alinhando as curvas DI e DAP por data. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data. Quando referenceDate for nulo, busca o último dado disponível no provedor e informa EffectiveDataDate no retorno.
 * @summary Constrói a curva de IPCA implícito
 */
const getBmfCurvesImpliedIpca = (
    params?: GetApiV1BmfCurvesImpliedIpcaParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesImpliedIpca200>>,) => {
      return customInstance<GetApiV1BmfCurvesImpliedIpca200>(
      {url: `/api/v1/bmf-curves/implied-ipca`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna a curva de euro derivada da curva de dólar ajustada pelo spread SDE: taxaEuro = (1 + taxaDólar) / (1 + SDE) − 1, nas bases 252 e 360. O forward de euro do source 87 não é usado (raso/ilíquido). Não há modo ao vivo: atende fechamento (D-1) e histórico (≤ D-2). Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data.
 * @summary Constrói a curva de euro BMF
 */
const getBmfCurvesEuro = (
    params?: GetApiV1BmfCurvesEuroParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesEuro200>>,) => {
      return customInstance<GetApiV1BmfCurvesEuro200>(
      {url: `/api/v1/bmf-curves/euro`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna a curva de cupom euro calculada pela multiplicação dos fatores do cupom dólar e da SDE TaxaSwap. Consulta primeiro o MongoDB; com forceUpdate=true recalcula no provedor e substitui o snapshot da data.
 * @summary Constrói a curva de cupom euro BMF
 */
const getBmfCurvesCupomEuro = (
    params?: GetApiV1BmfCurvesCupomEuroParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesCupomEuro200>>,) => {
      return customInstance<GetApiV1BmfCurvesCupomEuro200>(
      {url: `/api/v1/bmf-curves/cupom-euro`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Carrega a curva base do MongoDB ou calcula quando não houver snapshot, então calcula a taxa a termo. Os enums aparecem como seletores no Swagger por estarem em query string.
 * @summary Calcula taxa a termo de uma curva BMF por query string
 */
const getBmfCurvesTermCalculate = (
    params?: GetApiV1BmfCurvesTermCalculateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1BmfCurvesTermCalculate200>>,) => {
      return customInstance<GetApiV1BmfCurvesTermCalculate200>(
      {url: `/api/v1/bmf-curves/term/calculate`, method: 'GET',
        params
    },
      options);
    }
  return {getBmfCurvesDi,getBmfCurvesDap,getBmfCurvesDollar,getBmfCurvesCupomDollar,getBmfCurvesImpliedIpca,getBmfCurvesEuro,getBmfCurvesCupomEuro,getBmfCurvesTermCalculate}};
export type GetApiV1BmfCurvesDiResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesDi']>>>
export type GetApiV1BmfCurvesDapResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesDap']>>>
export type GetApiV1BmfCurvesDollarResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesDollar']>>>
export type GetApiV1BmfCurvesCupomDollarResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesCupomDollar']>>>
export type GetApiV1BmfCurvesImpliedIpcaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesImpliedIpca']>>>
export type GetApiV1BmfCurvesEuroResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesEuro']>>>
export type GetApiV1BmfCurvesCupomEuroResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesCupomEuro']>>>
export type GetApiV1BmfCurvesTermCalculateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getBmfCurves>['getBmfCurvesTermCalculate']>>>
